import { EmbedMessage } from '@/embed/EmbedMessage';
import type { EmbedWidgetProps } from '@/embed/types';

/**
 * The Account widget — a ready-but-empty placeholder. This is the natural home
 * for an account's reach-out summary once the sales reach-out feature lands;
 * for now the framework and registry entry exist so that is a small addition.
 *
 * @returns The Account actions placeholder.
 */
export function AccountActions(_props: EmbedWidgetProps): React.ReactElement {
  return <EmbedMessage text="bcecloud actions for an account will appear here as they are built." />;
}
